import { Col, Row } from "reactstrap";
import GraficaFijo from "../../../assets/img/Seguidores/graficacomparativafijo.jpg";
import Grafica1Eje from "../../../assets/img/Seguidores/graficacomparativa-1eje.jpg";
import Grafica2Ejes from "../../../assets/img/Seguidores/graficacomparativa-2ejes.jpg";

const Rentabilidad = () => {
  return (
    <Row className="p-2">
      <Col xs={12} sm={6} className="px-5 mt-5">
        <p className="font-weight-bold">
          Hasta un 25% más de energía que un sistema fijo
        </p>
        <ul class="mt-3">
          <li>
            El seguimiento acimutal a un eje presenta incrementos de generación
            de energía de hasta un 25% respecto a sistemas fijos a 30°. Como se
            puede apreciar en la gráfica, durante los meses de verano, la
            producción de energía es comparable a la producida por un sistema de
            doble eje.
          </li>
        </ul>
        <Row className="bgGraficaRentabilidad p-3 mt-3 rounded">
          <Col className="d-flex justify-content-center flex-column">
            <img src={GraficaFijo} />
            <p className="text-center">Fija</p>
          </Col>
          <Col className="d-flex justify-content-center flex-column">
            <img src={Grafica1Eje} />
            <p className="text-center">1 Eje</p>
          </Col>
          <Col className="d-flex justify-content-center flex-column">
            <img src={Grafica2Ejes} />
            <p className="text-center">Doble eje</p>
          </Col>
        </Row>
      </Col>

      <Col xs={12} sm={6} className="px-5 mt-5">
        <p className="font-weight-bold">
          Ocupación de parcela de un 30% superior respecto un sistema fijo
        </p>
        <ul class="mt-3">
          <li>
            A diferencia de otros sistemas de seguimiento a uno o dos ejes, el
            incremento de necesidad de espacio para un sistema acimutal en
            comparación con un sistema fijo es de aproximadamente un 30% . Esto
            hace que la diferencia en el coste y pérdidas del cableado sea
            mínima e inferior a la de los sistemas de seguimiento de doble eje.
          </li>
        </ul>
        <hr />
        <p className="font-weight-bold">Backtracking</p>
        <ul class="mt-3">
          <li>
            La electrónica de seguimiento utilizada por Avantsolar, elimina el
            sombreado parcial de los módulos, lo que previene de la disminución
            de rendimiento del sistema. El sombreado parcial es prácticamente
            imposible de eliminar en los seguidores de doble eje.
          </li>
        </ul>
      </Col>
    </Row>
  );
};

export default Rentabilidad;
